// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mZKK","footer":"styles_footer__pOc5W"};